import React from 'react';
import get from 'lodash/get'
import { Row, Col, Layout, message } from 'antd'
import Footer from '../../components/Footer/Footer'
import { validationServices } from "../../services"
import classes from './SaeRecording.css'
import SaeRecordingForm from '../../components/SaeRecording/SaeRecording'
import moment from 'moment'

const { Content } = Layout;

export default class SaeRecording extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            currentStep: 'Step 1',
            currentStepInt: 1,
            subjectID: '',
            userID: '',
            siteID: '',
            randomizationDate: '',
            randomizationGroup: '',
            randomizationWeight: '',
            randomizationTNKDose: '',
            randomizationTPABolusDose: '',
            randomizationTPAInfusionDose: '',
            consentExists: '',
            validationExists: '',
            validationExistsDate: '',
            validationExistsUsedRecommendedValues: '',
            validationExistsWeight: '',
            validationExistsGroup: '',
            validationExistsTNKDose: '',
            validationExistsTPABolusDose: '',
            saeDateInSiteTimezone: '',
            validationExistsTPAInfusionDose: '',
            validationExistsComments: '',
            validationExistsOptimizeRegistryID: '',
            validationExistsVialNumber: '',
            validationExistsVialExpiryDate: '',
            validationExistsSAEOccurred: '',
            validationExistsSAEType: '',
            validationExistsSAEDate: '',
            validationExistsSAEComments: '',
            other_event_comments: '',
            validationExistsOverwrite: false,
            validationSaved: false,
            submitted: false,
            loading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVialExpiryDatePickerChange = this.handleVialExpiryDatePickerChange.bind(this);
        this.handleSAEDatePickerChange = this.handleSAEDatePickerChange.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
    }

    handleChange = event => {
      const {name, value} = event.target;

      this.setState({
        [name]: value
      })
    }

    handleVialExpiryDatePickerChange = event => {
      this.setState({
        validationExistsVialExpiryDate: event
      })
    }

    handleSAEDatePickerChange = event => {
      this.setState({
        validationExistsSAEDate: event,
        validationExistsSAEDateMoment: moment(event)
      })
    }


    handleSubmit(values) {

        this.setState({
            loading: true,
            currentStep: 'Step 3',
            currentStepInt: 3
        });

        validationServices.create(values)
            .then(
                response => {
                    const validationResponse = response.data;


                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.setState({
                        validationExists: false,
                        validationExistsLink: '',
                        validationSaved: false,
                        submitted: false,
                        loading: false
                    });
                });
    }

    handleReset() {
        this.setState({
            currentStep: 'Step 1',
            currentStepInt: 1,
            subjectID: '',
            userID: '',
            siteID: '',
            randomizationDate: '',
            randomizationGroup: '',
            randomizationWeight: '',
            randomizationTNKDose: '',
            randomizationTPABolusDose: '',
            randomizationTPAInfusionDose: '',
            consentExists: '',
            validationExists: '',
            validationExistsDate: '',
            validationExistsUsedRecommendedValues: '',
            saeDateInSiteTimezone: '',
            validationExistsWeight: '',
            validationExistsGroup: '',
            validationExistsTNKDose: '',
            validationExistsTPABolusDose: '',
            validationExistsTPAInfusionDose: '',
            validationExistsComments: '',
            validationExistsOptimizeRegistryID: '',
            validationExistsVialNumber: '',
            validationExistsVialExpiryDate: '',
            validationExistsSAEOccurred: '',
            validationExistsSAEType: '',
            validationExistsSAEDate: '',
            validationExistsSAEComments: '',
            other_event_comments: '',
            validationExistsOverwrite: false,
            validationSaved: false,
            submitted: false,
            loading: false
        })
    }


    handleNext(values) {
      let {currentStep, currentStepInt} = this.state

      if (currentStep === 'Step 1') {
        this.setState({
          loading: true
        })

        validationServices.createSAE({
          site_id: this.state.siteID,
          user_id: this.state.userID,
          subject_id: this.state.subjectID,
          current_step: 1
        })
            .then(
                response => {
                    const validationResponse = response.data;

                    this.setState({
                        currentStep: 'Step 2',
                        currentStepInt: 2,
                        subjectID: validationResponse['subject_id'],
                        userID: validationResponse['user_id'],
                        siteID: validationResponse['site_id'],
                        saeDateInSiteTimezone: get(validationResponse, 'sae_date_in_site_timezone'),
                        validationExistsSAEOccurred: get(validationResponse, 'sae.is_sae_occurred', null),
                        isSAEOccurred: get(validationResponse, 'sae.is_sae_occurred', null),
                        validationExistsSAEType: get(validationResponse, 'sae.event_type'),
                        validationExistsSAEDate: get(validationResponse, 'sae.sae_date'),
                        validationExistsSAEDateMoment: moment.utc(get(validationResponse, 'sae.sae_date')).local(),
                        validationExistsSAEComments: get(validationResponse, 'sae.event_comments'),
                        other_event_comments: get(validationResponse, 'sae.other_event_comments'),
                        validationExistsOverwrite: false,
                        validationSaved: false,
                        submitted: false,
                        loading: false

                    });

                    if ( validationResponse['validationExistsSAEDateUTC'] === null ) {
                        this.setState({
                            validationExistsSAEDateMoment: null,
                        });
                    }

                    if ( validationResponse['validationExistsVialExpiryDateUTC'] === null ) {
                        this.setState({
                            validationExistsVialExpiryDateMoment: null
                        });
                    }

                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.setState({
                        currentStep: 'Step 1',
                        currentStepInt: 1,
                        validationSaved: false,
                        submitted: false,
                        loading: false
                    })
                });

      } else if ( (currentStep === 'Step 2')) {
        const validationExistsSAEOccurred = this.state.validationExistsSAEOccurred;

        this.setState({
          validationExistsOverwrite: true
        });

        this.setState({
          loading: true
        });

        validationServices.createSAE({
          site_id: this.state.siteID,
          user_id: this.state.userID,
          subject_id: this.state.subjectID,
          current_step: 2,
          sae: {
            "is_sae_occurred": validationExistsSAEOccurred === 'true' ? true : validationExistsSAEOccurred === 'false' ? false : null,
            "sae_date": moment(this.state.validationExistsSAEDateMoment.format('YYYY-MM-DDT') + moment().format('HH:mm')).utc().format('YYYY-MM-DDTHH:mm:ss'),
            "event_comments": this.state.validationExistsSAEComments,
            "event_type": this.state.validationExistsSAEType,
            "other_event_comments": this.state.other_event_comments,
          }
        })
            .then(
                response => {
                    const validationResponse = response.data;

                    this.setState({
                        currentStep: 'Step 3',
                        currentStepInt: 3,
                        subjectID: validationResponse['subject_id'],
                        userID: validationResponse['user_id'],
                        validationExistsSAEOccurred: get(validationResponse, 'sae.is_sae_occurred'),
                        validationExistsSAEType: get(validationResponse, 'sae.event_type'),
                        validationExistsSAEDate: get(validationResponse, 'sae_date_in_site_timezone'),
                        validationExistsSAEComments: get(validationResponse, 'sae.event_comments'),
                        other_event_comments: get(validationResponse, 'sae.other_event_comments'),
                        validationSaved: true,
                        submitted: false,
                        loading: false
                    });
                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.handleReset()
                });

      } else {
          this.handleReset()
      }

    }

    handlePrev = () => {
      let {currentStep, currentStepInt} = this.state
      if (currentStep === 'Step 2') {
            this.handleReset()
      } else if (currentStep === 'Step 3') {
            this.handleReset()
      }

    }


    render() {
        const { loading, validationSaved } = this.state;

        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                                <SaeRecordingForm loading={loading} {...this.state} handleChange={this.handleChange} handleVialExpiryDatePickerChange={this.handleVialExpiryDatePickerChange} handleSAEDatePickerChange={this.handleSAEDatePickerChange} handleSubmit={this.handleSubmit} handleNext={this.handleNext} handlePrev={this.handlePrev}/>
                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/SaeRecording/SaeRecording.js